export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const APP_LANGUAGES = JSON.parse(process.env.REACT_APP_LANGUAGES ?? '[]');
export const REACT_APP_TWITCH_CLIENT_ID = process.env.REACT_APP_TWITCH_CLIENT_ID;

export const REACT_APP_PRO_LIGHT_PRICE_ID = process.env.REACT_APP_PRO_LIGHT_PRICE_ID;
export const REACT_APP_PRO_LIGHT_PROUCT_ID = process.env.REACT_APP_PRO_LIGHT_PROUCT_ID;
export const REACT_APP_PRO_PRICE_ID = process.env.REACT_APP_PRO_PRICE_ID;
export const REACT_APP_PRO_PROUCT_ID = process.env.REACT_APP_PRO_PROUCT_ID;

export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;
export const REACT_APP_NAME = process.env.REACT_APP_NAME;

export const REACT_APP_CHAOS_OVERLAY_GITHUB_OWNER =
  process.env.REACT_APP_CHAOS_OVERLAY_GITHUB_OWNER || 'NKolva';
export const REACT_APP_CHAOS_OVERLAY_GITHUB_REPOSITORY =
  process.env.REACT_APP_CHAOS_OVERLAY_GITHUB_REPOSITORY || 're-chaos-overlay';
export const REACT_APP_CHAOS_OVERLAY_INSTALLER_FILENAME = 'RE-Chaos-Overlay-Setup.exe';
export const REACT_APP_CHAOS_OVERLAY_DOWNLOAD_URL = `https://github.com/${REACT_APP_CHAOS_OVERLAY_GITHUB_OWNER}/${REACT_APP_CHAOS_OVERLAY_GITHUB_REPOSITORY}/releases/latest/download/${REACT_APP_CHAOS_OVERLAY_INSTALLER_FILENAME}`;
